
import Typography from '@mui/material/Typography';


export const TextDrugClomipramine = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Clomipramine is used to treat people with obsessive-compulsive disorder (a condition that causes repeated unwanted thoughts and the need to 
perform certain behaviors over and over). Clomipramine is in a group of medications called tricyclic antidepressants. It works by increasing the 
amount of serotonin, a natural substance in the brain that is needed to maintain mental balance.
<br /><br />



Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a697002.html

</Typography>

</div>

)
}